import { HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Text, Pressable, Flex } from 'native-base';
import React from 'react';

import { ItemTagProps } from '.';

interface SelectableTagItemProps {
  item: string;
}

const gapWrapperStyle = { gap: 8 };

const SelectableTagItem: React.FC<SelectableTagItemProps> = ({ item }) => {
  return (
    <Pressable maxW={{ base: 'full', lg: '236px' }}>
      <HStack
        bgColor={Utils.ColorToken.WithOpacity('feedback.gen.lightest', 0.5)}
        alignItems="center"
        space={Spacing['inline.nano']}
        borderRadius={BoxRadius.xs}
        px={Spacing['inline.nano']}
        py={Spacing['inline.quarck']}>
        <Text
          maxW={{ lg: '200px' }}
          color="brand.tertiary.dark"
          variant="semibold"
          fontSize={{ base: Typography['fontsize.lg'], lg: Typography['fontsize.md'] }}>
          {item}
        </Text>
      </HStack>
    </Pressable>
  );
};

export const ItemTagContent: React.FC<ItemTagProps> = ({ data: customerTags }) => {
  return (
    <VStack space={Spacing['stack.xxxs']} w="full" maxH={400} overflow="auto">
      <Flex style={gapWrapperStyle} flexWrap="wrap" w="full" direction="row" bg="white">
        {customerTags.map((item) => {
          return <SelectableTagItem key={item} item={item} />;
        })}
      </Flex>
    </VStack>
  );
};
